import {
  Grid,
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { PropertyInfo } from "share-components/atomics/property-info";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const DetailInformation = observer(() => {
  const {
    customerManagement: { customerDetail },
  } = useStores();
  return (
    <Grid container spacing={2}>
      <Grid item xs={5}>
        <PropertyInfo
          title="Mã khách hàng:"
          value={customerDetail?.code || ""}
        ></PropertyInfo>
      </Grid>
      <Grid item xs={7}>
        <PropertyInfo
          title="Tên khách hàng:"
          value={customerDetail?.name || ""}
        ></PropertyInfo>
      </Grid>

      <Grid item xs={5}>
        <PropertyInfo
          title="Tên giao dịch:"
          value={customerDetail?.dealingName || ""}
        ></PropertyInfo>
      </Grid>

      <Grid item xs={7}>
        <PropertyInfo
          title="Loại khách hàng:"
          value={customerDetail?.customerType?.name || ""}
        ></PropertyInfo>
      </Grid>

      <Grid item xs={5}>
        <PropertyInfo
          title="Mã số thuế:"
          value={customerDetail?.taxCode || ""}
        ></PropertyInfo>
      </Grid>

      <Grid item xs={12}>
        <PropertyInfo
          title="Địa chỉ:"
          value={customerDetail?.headOfficeAddress || ""}
        ></PropertyInfo>
      </Grid>

      <Grid item xs={12}>
        <PropertyInfo
          title="Ghi chú:"
          value={customerDetail?.note || ""}
        ></PropertyInfo>
      </Grid>

      <Grid item xs={12} container spacing={1}>
        <Grid item xs={12}>
          <Typography
            variant="body2"
            fontWeight={(theme) => theme.typography.fontWeightMedium}
          >
            Thông tin giao hàng
          </Typography>
        </Grid>
        {customerDetail?.deliveryAddresses.map((x, idx) => (
          <Grid item xs={12} key={x.id}>
            <Stack direction={"row"} spacing={1} sx={{ marginLeft: "15px" }}>
              <Typography>{`Địa chỉ ${idx + 1}:`}</Typography>
              <Typography>{x.address}</Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
});

export const DetailInformationAsTable = observer(() => {
  const {
    customerManagement: { customerDetail },
  } = useStores();
  return (
    <>
      {" "}
      <XTablePagination hidePagination>
        <TableHead>
          <TableRow>
            <TableCell>Mã khách</TableCell>
            <TableCell>Loại khách </TableCell>
            <TableCell>Tên khách hàng</TableCell>
            <TableCell>Mã số thuế</TableCell>
            <TableCell>Địa chỉ trụ sở</TableCell>
            <TableCell>Tên giao dịch</TableCell>
            <TableCell>Địa chỉ giao hàng</TableCell>
            <TableCell>Ghi chú</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell
              sx={{
                minWidth: "100px",
              }}
            >
              {customerDetail?.code || ""}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "150px",
              }}
            >
              {customerDetail?.customerType?.name || ""}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "200px",
              }}
            >
              {customerDetail?.name || ""}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "100px",
              }}
            >
              {customerDetail?.taxCode || ""}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "200px",
              }}
            >
              {customerDetail?.headOfficeAddress || ""}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "150px",
              }}
            >
              {customerDetail?.dealingName || ""}
            </TableCell>
            <TableCell>
              {customerDetail?.deliveryAddresses.map((x, idx) => (
                <Grid item xs={12} key={x.id}>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    sx={{ marginLeft: "15px" }}
                  >
                    <Typography>{`-`}</Typography>
                    <Typography>{x.address}</Typography>
                  </Stack>
                </Grid>
              ))}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "200px",
              }}
            >
              {customerDetail?.note || ""}
            </TableCell>
          </TableRow>
        </TableBody>
      </XTablePagination>
    </>
  );
});
